<sh-badge
    [label]="label() | translate"
    [size]="size()"
    class="px-4 py-1"
    [style.background-color]="color()"
    style="--sh-public-badge-max-width: fit-content"
/>
